import serviceBase from '../../Services/serviceBase'
import {GetHeaderWithTokenMultiPart} from '../../../resources/Utils'
import axios from 'axios'

class CMSActions {
  getIarMember = async () => {
    let url = `${window._env_.COMMUNITY_API_URL}/iar-members`
    return serviceBase.get(url).then(
      (response) => {
        return response.data
      },
      (err) => {}
    )
  }

  getFireDepartment = async () => {
    let url = `${window._env_.COMMUNITY_API_URL}/fire-departments/department-by-id`
    return serviceBase.get(url).then(
      (response) => {
        return response.data
      },
      (err) => {}
    )
  }

  getDepartmentTimeBalanceHeader = async (id) => {
    let url = `${window._env_.COMMUNITY_API_URL}/department-time-balance/department-time-by-id?fireDepartmentId=${id}`
    return serviceBase.get(url).then(
      (response) => {
        return response.data
      },
      (err) => {}
    )
  }

  getAppConfiguration = async () => {
    let url = `${window._env_.COMMUNITY_API_URL}/app-configuration?type=cms`
    return serviceBase.get(url).then(
      (response) => {
        return response.data
      },
      (err) => {}
    )
  }

  deleteMemberImpersonationSession = async () => {
    try {
      let url = `${window._env_.COMMUNITY_API_URL}/iar-members/deleteImpersonateIARSession`
      const res = await serviceBase.delete(url)
      return res.status
    } catch (error) {
      console.log(error)
    }
  }

  saveSectionVideoProcess = async (sectionProcess) => {
    try {
      let url = `${window._env_.COMMUNITY_API_URL}/section-video-process`
      return serviceBase.post(url,sectionProcess).then(
        (response) => {
          return response.data
        },
        (err) => {
          console.error('error in save video process',err)
        }
      )
    }
    catch(error){
      console.error('error in save video process',error)
    }
  }

  sendToEncoderVideo = async (identifier, video, payload  ) =>{
    try {
      const f = new FormData();
      f.append("Identifier", identifier);
      f.append('File', video.binary, video.originalName)
      f.append("Payload", JSON.stringify(payload));

      //sending post
      let url = `${window._env_.MYLS_VIDEO_ENCODER_URL}/video/encode`

      const response = await axios.post(url, f, GetHeaderWithTokenMultiPart());
      //accepted
      if(response &&  response.status === 202)
        return response
      else{
        console.error('Error saving video encoder', response)
        return undefined
      }

    } catch (error) {
      console.error('Error sending video to encoder', error)
    }
  }
}

export default new CMSActions()

